export default __webpack_public_path__ + "static/media/flyingRock5.872e9252.webp";